import React from 'react';
import { Card } from '@/components/ui/card';
import { Radio } from 'lucide-react';
import { DASHBOARD } from '@/constants/testIds';
import liveBroadcastImg from '@/assets/live-broadcast.svg';

/**
 * Placeholder de "Mis directos" (Fase 06B pendiente).
 * Card con ilustración local (SVG vectorial reutilizable) de retransmisión
 * deportiva en directo + texto exacto requerido.
 */
export function MyLivesTab() {
  return (
    <Card
      data-testid={DASHBOARD.livesPlaceholder}
      className="rounded-2xl overflow-hidden border border-[var(--ns-border)] shadow-[var(--ns-shadow-soft)]"
    >
      <div className="relative aspect-[16/9] sm:aspect-[21/9] w-full bg-[#0c0a09]">
        <img
          src={liveBroadcastImg}
          alt="Estadio iluminado preparado para una retransmisión deportiva en directo"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-[11px] uppercase tracking-[0.2em] font-semibold">
            <Radio className="h-3.5 w-3.5" />
            Próximamente
          </span>
          <h3 className="mt-3 font-display uppercase tracking-tight text-white text-2xl sm:text-3xl leading-tight drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
            Mis directos
          </h3>
          <p className="mt-2 text-white/90 text-sm sm:text-base max-w-md drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)]">
            Los próximos directos disponibles aparecerán aquí.
          </p>
        </div>
      </div>
    </Card>
  );
}
